
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { CreditCard, AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Client } from '@/models/Client';
import { hasLowSessions, hasUnpaidSessions } from '@/utils/clientFilters';

interface ClientBadgesProps {
  client: Client;
}

const ClientBadges: React.FC<ClientBadgesProps> = ({ client }) => {
  const { t } = useTranslation();
  const clientHasUnpaidSessions = hasUnpaidSessions(client);
  
  // Check if any active subscription has low sessions (close to end or consumed)
  const clientHasLowSessions = client.subscriptions.some(sub => 
    sub.isActive && sub.currentCycleSessionsUsed >= sub.sessionsPerMonth - 1
  );

  return (
    <div className="flex flex-wrap gap-1">
      {clientHasUnpaidSessions && (
        <Badge 
          variant="outline"
          className="text-xs border-red-300 text-red-700 bg-red-50 dark:border-red-600 dark:text-red-300 dark:bg-red-900/20"
        >
          <CreditCard className="h-2.5 w-2.5 mr-1" />
          {t('clients.unpaid')}
        </Badge>
      )}
      {clientHasLowSessions && (
        <Badge 
          variant="outline" 
          className="text-xs border-orange-300 text-orange-700 bg-orange-50 dark:border-orange-600 dark:text-orange-300 dark:bg-orange-900/20"
        >
          <AlertCircle className="h-2.5 w-2.5 mr-1" />
          {t('clients.lowSessions')}
        </Badge>
      )}
    </div>
  );
};

export default ClientBadges;
